const languageObj = {
  'Sample photo': 'صورة عينة',
  Removing: 'جاري الإزالة',
  Edit: 'تحرير',
  'Adjust Picture': 'ضبط الصورة',
  Restore: 'يعيد',
  Eraser: 'ممحاة',
  Size: 'مقاس',
  Background: 'خلفية',
  Custom: 'مخصص',
  Presets: 'معد مسبقا',
  'Add Image': 'إضافة صورة',
  'Scale to Fit': 'مقياس للتناسب',
  'Full Width': 'عرض ملء الشاشة',
  'Full Height': 'ارتفاع ملء الشاشة',
  Move: 'تحرك',
  Undo: 'الغاء',
  Redo: 'اعادة',
  Enlarge: 'تكبير',
  Reduce: 'تصغير',
  //2022.09.28 xxy
  BGRemover: {
    title: 'مزيل الخلفية عبر الإنترنت  HitPaw',
    desc: 'إزالة خلفية صورك بسهولة بنسبة 100٪ تلقائيًا ومجانيًا',
    imgAlt: 'photo background remover',
    submitBtn: 'إزالة الخلفية',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Shadow",
  "Intensity" : "Opacity",
  "Radius" : "Radius",
  "Color" : "Color",
  "Move" : "Move Shadow",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Drag the shadow around in the image",
  "Upload failed, click to try again": "Upload failed, click to try again",
};

export default languageObj;
